<template>
  <div>
    <md-table class="order-list">
      <div class="text_medium">{{ type === ORDER_TYPES.buy ? i18n.trd_ask () : i18n.trd_bid() }}</div>

      <template v-if="list.length">
        <md-table-row>
          <md-table-head class="order-list__cell">{{ type === ORDER_TYPES.buy ? i18n.trd_want() : i18n.trd_order() }}</md-table-head>
          <md-table-head class="order-list__cell">{{ type === ORDER_TYPES.buy ? i18n.trd_order() : i18n.trd_want() }}</md-table-head>
          <md-table-head class="order-list__cell">{{ i18n.trd_price() }}</md-table-head>
        </md-table-row>

        <template v-for="(order, i) in list">
          <md-table-row class="order-list__row" :key="`${i}-order-row`" @click="matchOrder(order)">
            <md-table-cell class="order-list__cell">{{ roundCurrency(order.baseAmount, order.baseAssetCode) }} {{ order.baseAssetCode }}</md-table-cell>
            <md-table-cell class="order-list__cell">{{ roundCurrency(order.quoteAmount, order.quoteAssetCode) }} {{ order.quoteAssetCode }}</md-table-cell>
            <md-table-cell class="order-list__cell">{{ roundCurrency(order.price, order.quoteAssetCode) }} {{ order.quoteAssetCode }}</md-table-cell>
          </md-table-row>
        </template>

      </template>

      <template v-else>
        <div class="container__no-data">
          <md-icon class="md-size-4x">trending_up</md-icon>
          <div class="text_large">{{ i18n.trd_no_orders_history() }}</div>
          <div class="text_description text_margin text_medium">{{
            type === ORDER_TYPES.buy ?
            i18n.trd_here_will_be_the_order_ask_list() :
            i18n.trd_here_will_be_the_order_bid_list()
          }}</div>
        </div>
      </template>
    </md-table>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { ORDER_TYPES } from '@const'
  import OrderMakerMixin from '../order-maker.mixin'
  import SubmitterMixin from '@com/mixins/submitter.mixin'

  import { confirmAction } from '@js/modals/confirmation_message'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import {errors} from '@js/errors/factory'
  import {EventDispatcher} from '@js/events/event_dispatcher'
  import {ErrorHandler} from '@js/errors/error_handler'

  export default {
    name: 'order-list',
    mixins: [OrderMakerMixin, SubmitterMixin, CurrencyRound],
    data: _ => ({
      ORDER_TYPES,
      i18n
    }),
    props: {
      type: { type: String, required: true },
      list: { type: Array, required: true }
    },
    computed: {
      ...mapGetters([
        vuexTypes.factorData
      ])
    },
    methods: {
      ...mapActions({
        updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
      }),
      async matchOrder (order) {
        if (!await confirmAction({ message: i18n.trd_confirm_match() })) return
        this.disable()

        try {
          await this.createOrder({
            pair: {
              base: order.baseAssetCode,
              quote: order.quoteAssetCode
            },
            baseAmount: order.baseAmount,
            quoteAmount: order.quoteAmount,
            price: order.price,
            isBuy: !order.isBuy
          })
        } catch (error) {
          if (error instanceof errors.TFAExceededCodeError) {
            EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
          } else {
            ErrorHandler.processUnexpected(error)
          }
        }

        this.enable()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~scss/mixins";

  .order-list {
    max-height: 400px;
  }

  .order-list__row {
    cursor: pointer;
  }

  .orders__list {
    width: 100%;
  }

  .order-list__title {
    @include respond-to-custom(985px) {
      min-height: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/orders/Orders.List.vue